const getters = {
  id: state => state.user.id, // id: 用户ID
  name: state => state.user.name,
  avatar: state => state.user.avatar,
  token: state => state.user.token,
  userCode: state => state.user.userCode,
  userInfo: state => state.user.userInfo, //用户信息
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js